/**
 * One row per asset in the full CoinMetrics universe. `price` is the latest daily `ReferenceRateUSD`
 * close from the REST snapshot, overlaid live by the CoinMetrics websocket once a tick lands (see
 * `AssetLeaderboardEntity`).
 * `change24hPct`/`change7dPct` are null when there isn't enough daily lookback history yet
 * (e.g. a recently-listed asset); `change1hPct` comes from a separate hourly fetch and is null when
 * the asset has no fresh hourly price pair (see `useAssetLeaderboardOneHourChange`).
 * `spotVolumeUsd`/`marketCapUsd` are raw USD amounts.
 * `priceHistory` is the asset's DAILY closes for the lookback window, oldest to newest, with any
 * missing days dropped — feeds the CHANGE column's sparkline. Because it's daily-only, the 1H window
 * hides the sparkline rather than draw a multi-day line under a one-hour number (see
 * `AssetLeaderboardChangeCell`).
 */
export interface AssetLeaderboardRow {
  id: string;
  symbol: string;
  cmAssetId: string;
  price: number | null;
  change1hPct: number | null;
  change24hPct: number | null;
  change7dPct: number | null;
  spotVolumeUsd: number | null;
  marketCapUsd: number | null;
  priceHistory: number[];
}

/** Leaderboard-style sort shortcuts. Each maps to a fixed (column, direction) — see tokens.ts. */
export const AssetLeaderboardSortPreset = {
  Gainers: 'gainers',
  Volume: 'volume',
  MarketCap: 'marketCap',
} as const;
export type AssetLeaderboardSortPreset = (typeof AssetLeaderboardSortPreset)[keyof typeof AssetLeaderboardSortPreset];
